import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { StripeConnectOnboardingPage } from './stripe-connect-onboarding.page';
import { StripeConnectOnboardingPageRoutingModule } from './stripe-connect-onboarding-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    StripeConnectOnboardingPageRoutingModule
  ],
  declarations: [StripeConnectOnboardingPage],
  exports: [StripeConnectOnboardingPage]
})
export class StripeConnectOnboardingPageModule {} 